<!--
 * @Author: wangzhu
 * @Date: 2021-12-29 12:49:04
 * @LastEditTime: 2022-12-29 16:14:01
 * @LastEditors: wangzhu10 wangzhu10@jd.com
-->
<template>
    <div id="page8-wrapper">
      <div  class="badge-icon-wrap">
          <div class="badge-icon">
            <!-- <img class="badge-icon-center" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-14-3112EFHn31sZ0dlJOPG.png" /> -->
            <!-- <img class="badge-icon-light animate__animated  animate__pulse animate__infinite" src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-14-31AUx25fcLjWbrpgn0.png"/> -->
          </div>
        </div>
        <!-- <img src="https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-26-18-22IROg0QCTb6hsjJU.png" class="title-image  animate__animated animate__fadeInRight"/> -->
        <div class="page8-content animate__animated animate__jackInTheBox">
          <div class="page8-main">
            你共获得了<span class="report-num"> {{ reportData.badge.length }} </span>枚徽章<br>
            <span class="report-num-text" v-for="item in reportData.badge" :key="item.name">{{ item.name }}<br></span>
            JD产研的专属荣誉<br>
            只为每一个热爱技术的你<br>
          </div>
            <!-- <div class="page8-title">
              2022年全年积分清单
            </div>
            <div class="page8-tip">以下信息为根据积分规则实际计算结果，<br>
              详情可查看【个人主页-我的积分】</div>
            <div class="page8-list">
              <div class="page8-item">
                <span>
                  总分
                </span>
                <span>
                  <span class="page8-per">(超<span style="color:#e6a23c;">{{ percentage }}%</span>用户) </span>
                  <span class="report-num">{{ reportData.points }}</span>分
                </span>
              </div>
              <div class="page8-item">
                <span>
                  发布文章
                  <span><span class="report-num">{{ reportData.postNum }}</span></span>
                  篇
                </span>
                <span><span class="report-num">{{ reportData.point.post }}</span>分</span>
              </div>
              <div class="page8-item">
                <span>
                  签到
                  <span><span class="report-num">{{ reportData.checkInNum }}</span></span>
                  次
                </span>
                <span><span class="report-num">{{ reportData.point.checkIn }}</span>分</span>
              </div>
              <div class="page8-item">
                <span>
                  文章加精
                  <span><span class="report-num">{{ reportData.refinedNum }}</span></span>
                  次
                </span>
                <span><span class="report-num">{{ reportData.point.refined }}</span>分</span>
              </div>
              <div class="page8-item">
                <span>
                  文章发布外网
                  <span><span class="report-num">{{ reportData.jdCloudNum }}</span></span>
                  次
                </span>
                <span><span class="report-num">{{ reportData.point.cloud }}</span>分</span>
              </div>
              <div class="page8-item">
                <span>
                  发布畅聊
                  <span><span class="report-num">{{ reportData.questionNum }}</span></span>
                  个
                </span>
                <span><span class="report-num">{{ reportData.point.question }}</span>分</span>
              </div>
              <div class="page8-item">
                <span>
                  文章总阅读量
                  <span><span class="report-num">{{ reportData.readedNum }}</span></span>
                </span>
                <span><span class="report-num">{{ reportData.point.readNum }}</span>分</span>
              </div>
              <div class="page8-item">
                <span>
                  评论文章
                  <span><span class="report-num">{{ reportData.replyNum }}</span></span>
                  次
                </span>
                <span><span class="report-num">{{ reportData.point.postComment }}</span>分</span>
              </div >
              <div class="page8-item">
                <span>
                  评论畅聊
                  <span><span class="report-num">{{ reportData.replyQuestion }}</span></span>
                  次
                </span>
                <span><span class="report-num">{{ reportData.point.questionComment }}</span>分</span>
              </div>
              <div class="page8-item">
                <span>
                  分享文章阅读量
                  <span><span class="report-num">{{ reportData.sharedNum }}</span></span>
                </span>
                <span><span class="report-num">{{ reportData.point.shared }}</span>分</span>
              </div>
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'Page8',
    props: {
        reportData: {
            required: true,
            default: () => {},
        },
    },
    computed: {
      shortDept() {
        const list = this.reportData.department.split('-')
        return list[list.length - 1]
      },
      percentage() {
        const per = this.reportData.point?.percentage
        if (per) {
          return per.slice(0, 4) * 100
        }
        return 0
      }
    },
    methods: {
        handlePre() {
            this.$emit('pre');
        },
    },
};
</script>

<style lang="less" scoped>
#page8-wrapper {
    height: 100vh;
    width: 100%;
    // padding: 0 20px;
    background-image: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-28-18-53RdmFtktHBO53uBtO.jpg');
    
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    overflow: hidden;
    position: relative;
    .page8-content {
        // padding-top: 60px;
        font-size: 0.4rem;
        line-height: 2.8;
        color: #FAFAD7;
        font-weight: bold;
        // text-shadow: 1px 1px #f4e8e8;
    }
    .page8-title {
      line-height: 1;
      font-size: 28px;
      .page8-score {
        font-size: 15px;
      }
    }
    .page8-tip {
      color: #004176;
      font-size: 12px;
      line-height: 16px;
      margin-top: 4px;
      // margin: -14px 0 16px 0;
    }
    .page8-list {
        margin-top: 30px;
        padding: 0 50px;
    }
    .page8-item {
      display: flex;
      justify-content: space-between;
    }
    .page8-per {
      font-size: 12px;
    }
    .report-num {
        color: #f1f406;
        font-weight: 500;
        font-size: 0.55rem;
    }
    .report-num-text {
       color: #f1f406;
        font-weight: 500;
        font-size: 0.45rem; 
    }
    .page8-main {
       
      //  background: url('https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-12-25-17-27256rdGZkWqRnVgUk.png');
          background-size: 100% 100%;
          // width: 80%;
          // border-radius: 8px;
          margin: 3.5rem auto 0;
          // min-height: 45vh;
          // padding: 36px;
          box-sizing: border-box;
    }
    .badge-icon-wrap {
      position: absolute;
      bottom: 16px;
      right: 16px;
    }
    .badge-icon {
      height: 2.8rem;
      width: 2.8rem;
      position: relative;
    }
    .badge-icon-light {
      height: 100%;
      width: 100%;
    }
    .badge-icon-center {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      height: 50%;
      width: 50%;
      transform: translate(55%, 50%);
    }
    .title-image {
        height: 1.5rem;
        margin-top: 1.8rem;
    }
}
@media screen and (min-width: 1980px) {
  #page8-wrapper {
      .page8-main {
        margin-top: 25vh;
      }
    }
}
</style>
